<template>
  <div>
    <TriangleHeader :title="$t('supplier_form')"/>
    <v-form
        lazy-validation v-model="valid"
        ref="form">
      <div :class="$vuetify.breakpoint.mdAndDown?'w-100':'w-50'" class="mt-8 d-flex flex-column justify-center align-center text-center ma-auto">
        <h5 class="font-weight-bold mt-4">
          {{ $t('supplier_first_description') }}
        </h5>
        <h6 class="font-weight-bold mt-4">
          {{ $t('supplier_second_description') }}
        </h6>
        <h6 class="font-weight-bold">
          {{ $t('supplier_third_description') }}
        </h6>
        <h6 class="font-weight-bold">
          {{ $t('supplier_fourth_description') }}
        </h6>
        <div class="mt-16 question-box" v-for="(key,i) in Object.keys(form)">
          <h5 class="font-weight-bold question-category-title">{{ key }}</h5>
          <v-row class="mt-16">
            <!--      Input Form-->
            <v-col class="px-2 pb-1" v-for="(item,index) in form[key]" :key="index":cols="item.type==='input'?6:12">
              <p class="font-weight-bold my-0 text-right mr-2">{{ $t(item.label) }}</p>
              <div dir="auto" class="d-flex align-center mb-4" v-if="item.type==='row'">
                <v-row class="mt-4">
                  <v-col >
                    <p class="mb-2 font-weight-bold my-0 text-right mr-2" dir="auto">{{ $t('catalogue') }}</p>
                    <input type="file" @change=uploadCatalogue>
                  </v-col>
                  <v-col>
                    <p class="mb-2 font-weight-bold my-0 text-right mr-2" dir="auto">{{ $t('customers_list') }}</p>
                    <input type="file" @change=uploadCustomerList>
                  </v-col>
                </v-row>
              </div>
              <v-text-field
                  :rules="item.required?[...textRules,...(item.key == 'manager_email' || item.key == 'trade_agent_email' || item.key == 'company_email' || item.key == 'login_email' ? [rules.email]:[])]:''"
                  height="50"
                  v-if="item.type==='input'"
                  flat
                  dense
                  outlined
                  v-model="item.model"
              ></v-text-field>
              <v-text-field
                  :rules="item.required?[...textRules,...(item.key == 'manager_email' || item.key == 'trade_agent_email' || item.key == 'company_email' || item.key == 'login_email' ? [rules.email]:[])]:''"
                  height="50"
                  type="password"
                  v-else-if="item.type=='password'"
                  flat
                  dense
                  outlined
                  v-model="item.model"
              ></v-text-field>
            </v-col>
            <!--      End Input Form-->
          </v-row>
        </div>

        <div
            @click="register"
            class="app-btn my-4"
        >
          <v-progress-circular
              size="30"
              width="4"
              color="white"
              indeterminate
              v-if="loading"
          >

          </v-progress-circular>
          <p class="app-btn" v-else>{{  $t('create_new_account') }}</p>
        </div>
      </div>
    </v-form>
<v-dialog v-model="dialog" width="400">
  <v-card color="white" min-height="100">
    <v-card-text class="pt-4">
      <h4>{{$t('success_create_account')}}</h4>
    </v-card-text>
    <v-card-actions dir="ltr">
      <v-btn @click="$router.go(-1)" color="primary">{{$t('close')}}</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
    <v-snackbar
        :value="error"
        color="warning"
    >
      <p dir="auto" class="snackbar-text">{{ $t('wrong_supplier_form') }}</p>
    </v-snackbar>
    <v-snackbar
        :value="passError"
        color="warning"
    >
      <p dir="auto" class="snackbar-text">{{ $t('wrong_password') }}</p>
    </v-snackbar>
    <v-snackbar
        :value="isError && errors"
        color="warning"
    >
      <p dir="auto" class="snackbar-text"
         v-for="(error,key) in errors"  :key="i"
      >{{error[0]}}</p>
    </v-snackbar>
  </div>
</template>

<script>
import TriangleHeader from "../../components/triangle_header/TriangleHeader";
import {REGISTER_USER} from "../../store/authManagement/action_type";
import {mapState} from "vuex";

export default {
  name: "SuppliersForm",
  components: {TriangleHeader},
  data() {
    return {
      isError:false,
      textRules: [
        v => !!v || 'پر کردن این فیلد الزامی است',
      ],
      loading: false,
      valid: false,
      error: false,
      dialog: false,
      catalogue: null,
      customerList: '',
      passError: false,
      form: {
        "اطلاعات اصلی": [
          {
            label: 'First name',
            key: 'first_name',
            required: true,
            model: '',
            type: 'input',
            options: [],
          },
          {
            label: 'Last name',
            key: 'last_name',
            required: true,
            model: '',
            type: 'input',
            options: [],
          },
          {
            label: 'Father name',
            key: 'father_name',
            required: false,
            model: '',
            type: 'input',
            options: [],
          },
          {
            label: 'register_location',
            key: 'register_location',
            required: false,
            model: '',
            type: 'input',
            options: [],
          },
       
          {
            label: 'National Code',
            key: 'national_code',
            required: true,
            model: '',
            type: 'input',
            options: [],
          },
          {
            label: 'export_license',
            key: 'export_license',
            required: false,
            model: '',
            type: 'input',
            options: [],
          },
          {
            label: 'work_field',
            key: 'work_field',
            required: true,
            model: '',
            type: 'input',
            options: [],
          },
          {
            label: 'experience',
            key: 'experience',
            required: false,
            model: '',
            type: 'input',
            options: [],
          },
          {
            label: 'referrer',
            key: 'referrer',
            required: false,
            model: '',
            type: 'input',
            options: [],
          },
          {
            label: 'Unique code',
            key: 'unique_code',
            required: true,
            model: '',
            type: 'input',
            options: [],
          },
          {
            label: '',
            value: '',
            type: 'row',
            required: false,
          },
        ],
        "اطلاعات تماس": [
 

 
          {
            label: 'tel',
            key: 'tel',
            required: true,
            model: '',
            type: 'input',
            options: [],
          },
          {
            label: 'fax',
            key: 'fax',
            required: false,
            model: '',
            type: 'input',
            options: [],
          },

       
          {
            label: 'address',
            key: 'address',
            required: false,
            model: '',
            type: 'input',
            options: [],
          },
          
          {
            label: 'province_id',
            key: 'province_id',
            required: true,
            model: '',
            type: 'input',
            options: [],
          },
          {
            label: 'city_id',
            key: 'city_id',
            required: true,
            model: '',
            type: 'input',
            options: [],
          },
          {
            label: 'postcode',
            key: 'postcode',
            required: false,
            model: '',
            type: 'input',
            options: [],
          },
          {
            label: 'login_email',
            key: 'email',
            required: true,
            model: '',
            type: 'input',
            options: [],
          },
          {
            label: 'password',
            key: 'password',
            required: true,
            model: '',
            type: 'password',
            options: [],
          },
          {
            label: 'repeat_password',
            key: 'repeat_password',
            required: true,
            model: '',
            type: 'password',
            options: [],
          },
          {
            label: 'description',
            key: 'description',
            required: false,
            model: '',
            type: 'input',
            options: [],
          },
        ],

      },
      rules: {
          required: value => !!value || 'الزامی.',
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'ایمیل نامعتبر.'
          },
        },
    }
  },
  computed:{
    ...mapState({
      errors:state => state.authManagement.errorsList,
    })
  },
  methods: {
    uploadCatalogue(e) {
      console.log(e);
      const image = e.target.files[0];
      this.catalogue = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = e => {
        // this.catalogue = e.target.result;
        // console.log("file", this.catalogue);
      };
    },
    uploadCustomerList(e) {
      console.log(e);
      const image = e.target.files[0];
      this.customerList = e.target.files[0];

      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = e => {
        // this.customerList = e.target.result;
        // console.log("file", this.customerList);
      };
    },
    register() {
      this.isError=false;
      if (this.$refs.form.validate()) {
        if (this.catalogue != null) {
            this.loading = true;
            // var data = {};
            var data = new FormData();
            for (let i = 0; i < Object.keys(this.form).length; i++) {
              let currentCategory = this.form[Object.keys(this.form)[i]];
              for (let j = 0; j < currentCategory.length; j++) {
                var item = currentCategory[j];
                if (item.type !== 'row') {
                  data.append(item.key, item.model)
                }
              }
            }
            data.append('catalogue', this.catalogue);
            data.append('customerList', this.customerList);
            data.append('person_type', 'person');
            data.api_key = '402784613679330';
            this.$store.dispatch(`authManagement/${REGISTER_USER}`, data).then(
                success => {
                  this.loading = false;
                  if (success){
                    this.dialog = true;
                  }
                  else{
                    this.isError=true;
                  }
                }
            );
          } else {
            this.error = true;
          }
      }
    },
  },
}
</script>

<style scoped>

</style>